module.exports = __webpack_public_path__ + "img/button_contact_on.d4de89f7.png";